export default "__VITE_ASSET__Bazp935q__"